// tslint:disable
/**
 * Line Push Message Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __assign, __extends } from "tslib";
import * as globalImportUrl from 'url';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, BaseAPI, RequiredError } from './base';
/**
 * MessageApi - axios parameter creator
 * @export
 */
export var MessageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * 特定のユーザにメッセージを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendMessageRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling sendMessage.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendMessage.');
            }
            var localVarPath = "/api/v1/message/user/{user_id}/sendMessage"
                .replace("{" + "user_id" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 特定のユーザに診断結果を送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendResultRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResult: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling sendResult.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendResult.');
            }
            var localVarPath = "/api/v1/message/user/{user_id}/sendResult"
                .replace("{" + "user_id" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MessageApi - functional programming interface
 * @export
 */
export var MessageApiFp = function (configuration) {
    return {
        /**
         * 特定のユーザにメッセージを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendMessageRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, body, options) {
            var localVarAxiosArgs = MessageApiAxiosParamCreator(configuration).sendMessage(userId, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 特定のユーザに診断結果を送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendResultRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResult: function (userId, body, options) {
            var localVarAxiosArgs = MessageApiAxiosParamCreator(configuration).sendResult(userId, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MessageApi - factory interface
 * @export
 */
export var MessageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * 特定のユーザにメッセージを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendMessageRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, body, options) {
            return MessageApiFp(configuration).sendMessage(userId, body, options)(axios, basePath);
        },
        /**
         * 特定のユーザに診断結果を送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelSendResultRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResult: function (userId, body, options) {
            return MessageApiFp(configuration).sendResult(userId, body, options)(axios, basePath);
        },
    };
};
/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
var MessageApi = /** @class */ (function (_super) {
    __extends(MessageApi, _super);
    function MessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 特定のユーザにメッセージを送信する
     * @param {string} userId 配信先のユーザID
     * @param {ModelSendMessageRequest} body リクエスト情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.sendMessage = function (userId, body, options) {
        return MessageApiFp(this.configuration).sendMessage(userId, body, options)(this.axios, this.basePath);
    };
    /**
     * 特定のユーザに診断結果を送信する
     * @param {string} userId 配信先のユーザID
     * @param {ModelSendResultRequest} body リクエスト情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.sendResult = function (userId, body, options) {
        return MessageApiFp(this.configuration).sendResult(userId, body, options)(this.axios, this.basePath);
    };
    return MessageApi;
}(BaseAPI));
export { MessageApi };
/**
 * RichMenuApi - axios parameter creator
 * @export
 */
export var RichMenuApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * リッチメニューをユーザに紐づけて作成する
         * @param {ModelCreateRichMenuRequest} body リッチメニュー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRichMenu: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createRichMenu.');
            }
            var localVarPath = "/api/v1/richMenu";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RichMenuApi - functional programming interface
 * @export
 */
export var RichMenuApiFp = function (configuration) {
    return {
        /**
         * リッチメニューをユーザに紐づけて作成する
         * @param {ModelCreateRichMenuRequest} body リッチメニュー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRichMenu: function (body, options) {
            var localVarAxiosArgs = RichMenuApiAxiosParamCreator(configuration).createRichMenu(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RichMenuApi - factory interface
 * @export
 */
export var RichMenuApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * リッチメニューをユーザに紐づけて作成する
         * @param {ModelCreateRichMenuRequest} body リッチメニュー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRichMenu: function (body, options) {
            return RichMenuApiFp(configuration).createRichMenu(body, options)(axios, basePath);
        },
    };
};
/**
 * RichMenuApi - object-oriented interface
 * @export
 * @class RichMenuApi
 * @extends {BaseAPI}
 */
var RichMenuApi = /** @class */ (function (_super) {
    __extends(RichMenuApi, _super);
    function RichMenuApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * リッチメニューをユーザに紐づけて作成する
     * @param {ModelCreateRichMenuRequest} body リッチメニュー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RichMenuApi
     */
    RichMenuApi.prototype.createRichMenu = function (body, options) {
        return RichMenuApiFp(this.configuration).createRichMenu(body, options)(this.axios, this.basePath);
    };
    return RichMenuApi;
}(BaseAPI));
export { RichMenuApi };
/**
 * ScenarioApi - axios parameter creator
 * @export
 */
export var ScenarioApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * シナリオを作成する
         * @param {ModelCreateScenarioRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createScenario.');
            }
            var localVarPath = "/api/v1/scenario";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ScenarioApi - functional programming interface
 * @export
 */
export var ScenarioApiFp = function (configuration) {
    return {
        /**
         * シナリオを作成する
         * @param {ModelCreateScenarioRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).createScenario(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ScenarioApi - factory interface
 * @export
 */
export var ScenarioApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * シナリオを作成する
         * @param {ModelCreateScenarioRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            return ScenarioApiFp(configuration).createScenario(body, options)(axios, basePath);
        },
    };
};
/**
 * ScenarioApi - object-oriented interface
 * @export
 * @class ScenarioApi
 * @extends {BaseAPI}
 */
var ScenarioApi = /** @class */ (function (_super) {
    __extends(ScenarioApi, _super);
    function ScenarioApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * シナリオを作成する
     * @param {ModelCreateScenarioRequest} body リクエスト情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.createScenario = function (body, options) {
        return ScenarioApiFp(this.configuration).createScenario(body, options)(this.axios, this.basePath);
    };
    return ScenarioApi;
}(BaseAPI));
export { ScenarioApi };
/**
 * StepApi - axios parameter creator
 * @export
 */
export var StepApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} scenarioName 送信するシナリオ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByScenario: function (scenarioName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'scenarioName' is not null or undefined
            if (scenarioName === null || scenarioName === undefined) {
                throw new RequiredError('scenarioName', 'Required parameter scenarioName was null or undefined when calling sendStepByScenario.');
            }
            var localVarPath = "/api/v1/step/scenario/{scenarioName}"
                .replace("{" + "scenarioName" + "}", encodeURIComponent(String(scenarioName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelStepSendRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByUser: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling sendStepByUser.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendStepByUser.');
            }
            var localVarPath = "/api/v1/step/user/{user_id}"
                .replace("{" + "user_id" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * StepApi - functional programming interface
 * @export
 */
export var StepApiFp = function (configuration) {
    return {
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} scenarioName 送信するシナリオ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByScenario: function (scenarioName, options) {
            var localVarAxiosArgs = StepApiAxiosParamCreator(configuration).sendStepByScenario(scenarioName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelStepSendRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByUser: function (userId, body, options) {
            var localVarAxiosArgs = StepApiAxiosParamCreator(configuration).sendStepByUser(userId, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * StepApi - factory interface
 * @export
 */
export var StepApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} scenarioName 送信するシナリオ名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByScenario: function (scenarioName, options) {
            return StepApiFp(configuration).sendStepByScenario(scenarioName, options)(axios, basePath);
        },
        /**
         * 特定のステップ配信のステップIDを送信する
         * @param {string} userId 配信先のユーザID
         * @param {ModelStepSendRequest} body リクエスト情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendStepByUser: function (userId, body, options) {
            return StepApiFp(configuration).sendStepByUser(userId, body, options)(axios, basePath);
        },
    };
};
/**
 * StepApi - object-oriented interface
 * @export
 * @class StepApi
 * @extends {BaseAPI}
 */
var StepApi = /** @class */ (function (_super) {
    __extends(StepApi, _super);
    function StepApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 特定のステップ配信のステップIDを送信する
     * @param {string} scenarioName 送信するシナリオ名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepApi
     */
    StepApi.prototype.sendStepByScenario = function (scenarioName, options) {
        return StepApiFp(this.configuration).sendStepByScenario(scenarioName, options)(this.axios, this.basePath);
    };
    /**
     * 特定のステップ配信のステップIDを送信する
     * @param {string} userId 配信先のユーザID
     * @param {ModelStepSendRequest} body リクエスト情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StepApi
     */
    StepApi.prototype.sendStepByUser = function (userId, body, options) {
        return StepApiFp(this.configuration).sendStepByUser(userId, body, options)(this.axios, this.basePath);
    };
    return StepApi;
}(BaseAPI));
export { StepApi };
